module.exports = __webpack_public_path__ + "media/dashboard/assets/icons/ic_love-9eed712521f77c4f4cae4c7395bff23d.svg";